import React, { Component } from 'react';
import Modal from 'react-modal';

import PropTypes from 'prop-types';
import Button from 'react-toolbox/lib/button';
import Checkbox from 'material-ui/Checkbox';
import cn from 'classnames';
import styles from './Tutorial.scss';// to import local scss fle
import data from './TutorialData';

const TutorialBox = props => (
  <div className={styles.containerBox}>
    <div className={styles.imageContainer}>
      <img alt="filter icon" src={`https://s3.amazonaws.com/myrbmedia-dev/Images/${props.data.image}`} className={styles.filterImage} />
    </div>
    <div className={styles.filterDescription}>
      {props.data.text}
      {props.data.header === 'Recommendations' ? <span className={styles.notifyRed} >You can contact up to 10 colleges per day while subscribed.</span> : ''}
    </div>
  </div>
);

TutorialBox.propTypes = {
  data: PropTypes.shape().isRequired,
};

const titles = {
  0: 'RECOMMENDATIONS',
  1: 'FILTER',
  2: 'LOAD MORE',
};

const checkboxStyles = {
  checkbox: {
    marginBottom: 16,
  },
  labelStyle: {
    fontSize: 12,
  },
  iconStyle: {
    fill: '#4a90e2',
  },
};


class Tutorials extends Component {
  // static propTypes = {
  //
  // };
  static defaultProps = {
    history: {
      push: () => {},
    },
  };
  constructor(props) {
    super(props);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.state = {
      open: true,
      title: 'RECOMMENDATIONS',
      tab: 0,
      checked: false,
    };
  }
  onCloseModal() {
    this.setState({ open: false });
  }
  updateCheck = () => {
    this.setState({ checked: !this.state.checked });
    window.localStorage.setItem('count', 111);
  };

  updateTab = () => {
    if (this.state.tab === 2) {
      const count = window.localStorage.getItem('count');
      if (count === undefined) {
        window.localStorage.setItem('count', 1);
      } else if (!this.state.checked) {
          window.localStorage.setItem('count', count + 1 ); //eslint-disable-line
      }
      this.onCloseModal();
    } else {
      this.setState({ tab: this.state.tab + 1 });
    }
  };

  render() {
    const modalStyle = {
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        zIndex: 1,
      },
      // content: {
      //   top: '50%',
      //   left: '50%',
      //   right: 'auto',
      //   bottom: 'auto',
      //   marginRight: '-50%',
      //   minHeight: '300px',
      //   transform: 'translate(-50%, -50%)',
      // },
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        minHeight: '300px',
        paddingTop: '20px',
        paddingLeft: '0px',
        paddingRight: '0px',
        paddingBottom: '0',
        transform: 'translate(-50%, -50%)',
      },
    };
    const { open, tab } = this.state;
    return (
      <div>
        <Modal style={modalStyle} isOpen={open} >
          <div className={cn('row', styles.container)}>
            <button className={styles.absoluteCross} onClick={this.onCloseModal}>
           x
           </button>
            <div className={cn('col s12', styles.header)} >
              {titles[tab]}
            </div>
            <div className={styles.tutorialData}>
              <TutorialBox data={data[tab]} />
            </div>
            <div className={cn('col s12', styles.dontShowMeagain)}>
              <div className={cn('col s12 m8')}>
                <Checkbox
                  label="Don't show this message again."
                  checked={this.state.checked}
                  onCheck={this.updateCheck}
                  labelStyle={checkboxStyles.labelStyle}
                  iconStyle={checkboxStyles.iconStyle}
                />
              </div>
              <div className={cn('col s12 m4', styles.helpButtons)}>
                <Button className={styles.nextButton} onClick={this.updateTab}>NEXT</Button>
              </div>
            </div>

          </div>

          {/* <div> */}
          {/* </div> */}
          {/* </div> */}
        </Modal>
      </div>
    );
  }
}

export default Tutorials;



// WEBPACK FOOTER //
// ./src/components/DashboardView/Tutorial/Tutorial.js